import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_platforms_loader = _resolveComponent("platforms-loader")!
  const _component_platform_icon = _resolveComponent("platform-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_platforms_loader, {
      "social-sites": _ctx.platforms,
      onLoaded: _ctx.onLoaded
    }, null, 8, ["social-sites", "onLoaded"]),
    _createVNode(_component_q_list, {
      class: "rounded-borders full-height",
      bordered: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, (platform) => {
          return (_openBlock(), _createElementBlock("div", {
            key: platform.id
          }, [
            _createVNode(_component_q_expansion_item, {
              "model-value": _ctx.isActive(platform.id),
              "header-class": "bg-white",
              "header-style": { position: 'sticky', top: '-16px', left: 0, right: 0, zIndex: 100 },
              group: "platforms",
              "onUpdate:modelValue": ($event: any) => (_ctx.onToggle($event, platform))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_platform_icon, {
                      "social-site": platform,
                      size: "2rem",
                      class: "on-left"
                    }, null, 8, ["social-site"])
                  ]),
                  _: 2
                }, 1024),
                _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps({ platform, isActive: _ctx.isActive(platform.id) })), () => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-body1", { 'text-weight-bold': _ctx.isActive(platform.id) }])
                      }, _toDisplayString(platform.name), 3)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ platform })))
              ]),
              _: 2
            }, 1032, ["model-value", "onUpdate:modelValue"]),
            _createVNode(_component_q_separator)
          ]))
        }), 128))
      ]),
      _: 3
    })
  ]))
}